import { FC } from 'react';
import { withBestEffort } from '../error/BestEffort';
import { QuickLinkType } from './links.types';
import { MiniPictureLink } from './MiniPictureLink';
import { CategoryType, useCategoryDetails } from '../../services/api/hooks/categories';

interface Props {
  category: CategoryType
}

const CategorySmallLinkContent: FC<Props> = ({ category }) => {
  const { imageUrl } = useCategoryDetails(category.id); 

  const link: QuickLinkType = {
    title: category.name,
    subtitle: category.description,
    to: `/documents/categories/${category.id}`,
    pictureUrl: imageUrl
  };

  return <MiniPictureLink link={link} key={link.title} />;
};

export const CategorySmallLink = withBestEffort(CategorySmallLinkContent);
